import { Hypothesis, HypothesisResponse, UpdateHypothesis, UpdateHypothesisDto } from '../types'
import { filterObjectNullableValues } from '@/shared/lib/helpers/object-methods'
import { CreateHypothesis, CreateHypothesisDto } from '../types'

function isValidDate(dateString: string) {
  const date = new Date(dateString)
  return !isNaN(date.getTime())
}

function mapHypothesis(dto: Partial<HypothesisResponse>): Hypothesis {
  return {
    id: String(dto?.id || ''),
    hypothesisId: String(dto?.id || ''),
    userId: String(dto?.user_id || ''),
    projectId: String(dto?.project_id || ''),
    hypotheseId: String(dto?.hypothese_id || ''),
    hypotheses: dto?.hypotheses || '',
    raceId: String(dto?.race_id || ''),
    toolId: String(dto?.tool_id || ''),
    toolCustom: dto?.tool_custom || '',
    answerHypothese: dto?.answer_hypothese || '',
    action: dto?.action || '',
    markId: String(dto?.mark?.id || ''),
    markName: dto?.mark?.name || '',
    markCustom: dto?.mark_custom || '',
    markTypeId: String(dto?.mark_type?.id || ''),
    markTypeType1: dto?.mark_type?.mark_type1 || '',
    markTypeType2: dto?.mark_type?.mark_type2 || '',
    markTypeType3: dto?.mark_type?.mark_type3 || '',
    planningResult: dto?.planing_result || '',
    dateRangeStart: !isValidDate(dto?.date_range_start || '') ? '' : dto?.date_range_start || '',
    dateRangeEnd: !isValidDate(dto?.date_range_end || '') ? '' : dto?.date_range_end || '',
    statusId: String(dto?.status_id || ''),
    dateStart: dto?.date_start || '',
    dateEdit: dto?.date_edit || '',
    dateEnd: dto?.date_end || '',
    fact: dto?.fact || '',
    conclusions: dto?.conclusions || '',
    hypotheseCustom: dto?.hypothese_custom || '',
    createdAt: dto?.created_at || '',
    updatedAt: dto?.updated_at || '',
    userFunnelStep: dto?.user_funnel_step || '',
    growthPointId: String(dto?.growth_point_id || ''),
    isSuccess: !!dto?.is_success,
    processStatus: dto?.process_status || '',
    premise: dto?.premise || '',
    expectedResult: dto?.expected_result || '',
    script: dto?.script || '',
    kindId: String(dto?.kind?.id || ''),
    kindName: dto?.kind?.name || '',
    priorityId: String(dto?.priority?.id || ''),
    priorityName: dto?.priority?.name || '',
    statusName: dto?.status?.name || '',
    toolBlock: dto?.tool?.block || '',
    toolName: dto?.tool?.name || '',
    achievementStatus: !!dto?.is_success ? '1' : '0',
  }
}

function mapHypotheses(response: Partial<HypothesisResponse>[]): Hypothesis[] {
  return response.map((dto) => {
    return mapHypothesis(dto)
  })
}

export function mapUpdateHypothesis(dto: Partial<UpdateHypothesisDto>): UpdateHypothesis {
  return {
    id: String(dto?.id || ''),
    userId: String(dto?.user_id || ''),
    projectId: String(dto?.project_id || ''),
    kindId: String(dto?.hypothese_id || ''),
    hypotheses: dto?.hypotheses || '',
    raceId: String(dto?.race_id || ''),
    toolId: String(dto?.tool_id || ''),
    toolCustom: dto?.tool_custom || '',
    answerHypothese: dto?.answer_hypothese || '',
    action: dto?.action || '',
    priorityId: String(dto?.priority_id || ''),
    markId: String(dto?.mark || ''),
    markCustom: dto?.mark_custom || '',
    markTypeId: String(dto?.mark_type || ''),
    planningResult: dto?.planing_result || '',
    dateRangeStart: dto?.date_range_start || '',
    dateRangeEnd: dto?.date_range_end || '',
    statusId: String(dto?.status_id || ''),
    dateStart: dto?.date_start || '',
    dateEdit: dto?.date_edit || '',
    fact: dto?.fact || '',
    conclusions: dto?.conclusions || '',
    hypotheseCustom: dto?.hypothese_custom || '',
    createdAt: dto?.created_at || '',
    updatedAt: dto?.updated_at || '',
    userFunnelStep: dto?.user_funnel_step || '',
    growthPointId: String(dto?.growth_point_id || ''),
    isSuccess: dto?.is_success || '',
    processStatus: dto?.process_status || '',
    premise: dto?.premise || '',
    expectedResult: dto?.expected_result || '',
    script: dto?.script || '',
    hypothesisId: String(dto?.hypothesis_id || ''),
    achievementStatus: !!dto?.is_success ? '1' : '0',
  }
}

export function mapUpdateHypothesisToDto(dto: Partial<UpdateHypothesis>): UpdateHypothesisDto {
  const result: any = {}

  if (dto.id !== undefined) result.id = dto.id || ''
  if (dto.userId !== undefined) result.user_id = dto.userId || ''
  if (dto.projectId !== undefined) result.project_id = dto.projectId || ''
  if (dto.kindId !== undefined) result.hypothese_id = dto.kindId || ''
  if (dto.hypotheses !== undefined) result.hypotheses = dto.hypotheses || ''
  if (dto.raceId !== undefined) result.race_id = dto.raceId || ''
  if (dto.toolId !== undefined) result.tool_id = dto.toolId || ''
  if (dto.toolCustom !== undefined) result.tool_custom = dto.toolCustom || ''
  if (dto.answerHypothese !== undefined) result.answer_hypothese = dto.answerHypothese || ''
  if (dto.action !== undefined) result.action = dto.action || ''
  if (dto.priorityId !== undefined) result.priority_id = dto.priorityId || ''
  if (dto.markId !== undefined) result.mark = dto.markId || ''
  if (dto.markCustom !== undefined) result.mark_custom = dto.markCustom || ''
  if (dto.markTypeId !== undefined) result.mark_type = dto.markTypeId || ''
  if (dto.planningResult !== undefined) result.planing_result = dto.planningResult || ''
  if (dto.dateRangeStart !== undefined) result.date_range_start = dto.dateRangeStart || ''
  if (dto.dateRangeEnd !== undefined) result.date_range_end = dto.dateRangeEnd || ''
  if (dto.statusId !== undefined) result.status_id = dto.statusId || ''
  if (dto.dateStart !== undefined) result.date_start = dto.dateStart || ''
  if (dto.dateEdit !== undefined) result.date_edit = dto.dateEdit || ''
  if (dto.fact !== undefined) result.fact = dto.fact || ''
  if (dto.conclusions !== undefined) result.conclusions = dto.conclusions || ''
  if (dto.hypotheseCustom !== undefined) result.hypothese_custom = dto.hypotheseCustom || ''
  if (dto.createdAt !== undefined) result.created_at = dto.createdAt || ''
  if (dto.updatedAt !== undefined) result.updated_at = dto.updatedAt || ''
  if (dto.userFunnelStep !== undefined) result.user_funnel_step = dto.userFunnelStep || ''
  if (dto.growthPointId !== undefined) result.growth_point_id = dto.growthPointId || ''
  if (dto.achievementStatus !== undefined) result.is_success = dto.achievementStatus == '1'
  if (dto.processStatus !== undefined) result.process_status = dto.processStatus || ''
  if (dto.premise !== undefined) result.premise = dto.premise || ''
  if (dto.expectedResult !== undefined) result.expected_result = dto.expectedResult || ''
  if (dto.script !== undefined) result.script = dto.script || ''
  if (dto.hypothesisId !== undefined) result.hypothesis_id = dto.hypothesisId || ''
  if (dto.isSuccess !== undefined) result.achievement_status = !!dto.isSuccess ? 1 : 0

  return filterObjectNullableValues<UpdateHypothesisDto>(result)
}

export function mapCreateHypothesisToDto(dto: Partial<CreateHypothesis>): CreateHypothesisDto {
  return {
    mark: {
      id: dto?.mark?.id || 0,
      name: dto?.mark?.name || '',
    },
    kind: {
      id: dto?.kind?.id || 0,
      name: dto?.kind?.name || '',
    },
    priority: {
      id: dto?.priority?.id || 0,
      name: dto?.priority?.name || '',
    },
    mark_type: {
      id: dto?.markType?.id || 0,
      mark_type: dto?.markType?.mark_type || '',
      mark_type1: dto?.markType?.mark_type1 || '',
      mark_type2: dto?.markType?.mark_type2 || '',
      mark_type3: dto?.markType?.mark_type3 || '',
    },
    tool: {
      id: dto?.tool?.id || 0,
      name: dto?.tool?.name || '',
      tool: dto?.tool?.tool || '',
      active: dto?.tool?.active || '',
    },
    status: dto?.status || null,
    process_status: dto?.processStatus || null,
    is_success: dto?.isSuccess ?? false,
    premise: dto?.premise || '',
    expected_result: dto?.expectedResult || '',
    script: dto?.script || '',
    planing_result: dto?.planningResult || '',
    fact: dto?.fact || null,
    conclusions: dto?.conclusions || null,
    date_range_start: dto?.dateRange?.start || dto?.dateRangeStart || '',
    date_range_end: dto?.dateRange?.end || dto?.dateRangeEnd || '',
    user_funnel_step: dto?.userFunnelStep || null,
    growth_point_id: dto!.growthPointId!,
    user_task_id: dto!.userTaskId!,
  }
}

const mappers = {
  mapHypotheses,
  mapUpdateHypothesis,
  mapUpdateHypothesisToDto,
  mapHypothesis,
  mapCreateHypothesisToDto,
}

export default mappers
